import { formatTimeToShow } from '@op/utils/time';
import { useIntl } from 'umi';
import React, { useMemo, useRef } from 'react';
import { formatChartParamsDate } from '@op/components/ChartCommon/formatter';
import { NO_DATE } from '@op/constants';
import { getPercentageInfo, mathFormat } from '@op/utils';
import { reviewsFormat } from '@op/utils/value';
import EChartCommon from '@op/components/EChartCommon';
import { labelFormat } from '@op/pages/Overview/KeyMetrics/MentionsSentiment/MetricsChart/utils';
import { getLegendFormat } from '@op/pages/Overview/KeyMetrics/MentionsSentiment/MetricsChart/Charts/utils';
import { textShowFun } from '@op/pages/Performance/components/MentionsSentiment/commonOption';

interface IPieChart {
  filter: any;
  data: any;
  height?: number;
}
export default function Index(props: IPieChart) {
  const { filter, data, height = 300 } = props;
  const { formatMessage } = useIntl();
  const eChartsRef = useRef(null as any);

  const options = useMemo(() => {
    const { pieTotalData, pieData } = data || {};
    const total = pieTotalData || 0;
    const pieDataList = pieData || [];
    return {
      tooltip: {
        className: 'dbo-mentions-sentiment-box-tooltip-wrapper',
        enterable: true,
        formatter: (params: any) => formatChartParamsDate({
          title: formatTimeToShow(filter),
          params,
          listTitleFunc: (item) =>
            formatMessage({ id: item.name || NO_DATE.EMPTY }),
          valueFormat: (value) => {
            const percent = getPercentageInfo(params?.value, total, 2);
            return `${isNaN(value) ? '-' : reviewsFormat(value)}(${percent})`;
          },
          textShowFun: textShowFun(formatMessage),
        }),
      },
      title: [
        {
          text: `{name|${mathFormat(total)}}`,
          top: '43%',
          left: 'center',
          textStyle: {
            rich: {
              name: {
                fontSize: 24,
                fontFamily: 'num-m',
                color: '#000000',
                padding: [10, 0],
              },
            },
          },
        },
      ],
      series: [
        {
          data: pieDataList,
          label: {
            color: '#262832',
            formatter: labelFormat(formatMessage, total),
            rich: {
              a: {
                // color: '#999',
                lineHeight: 20, // 设置最后一行空数据高度，为了能让延长线与hr线对接起来
                align: 'center',
              },
              hr: {
                // 设置hr是为了让中间线能够自适应长度
                borderColor: 'auto', // hr的颜色为auto时候会主动显示颜色的
                width: '105%',
                borderWidth: 0.5,
                height: 0.5,
              },
              per: {
                // 用百分比数据来调整下数字位置，显的好看些。如果不设置，formatter最后一行的空数据就不需要
                padding: [4, 0],
              },
            },
          },
          labelLayout: (params: any) => {
            const isLeft =
              params.labelRect.x <
              eChartsRef?.current?.getEchartsInstance?.()?.getWidth() / 2;
            const points = params.labelLinePoints;
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width;
            return {
              labelLinePoints: points,
            };
          },
          emphasis: {
            focus: 'self',
            label: {
              opacity: 0.2,
            },
            labelLine: {
              lineStyle: {
                opacity: 0.2,
              },
            },
          },
          blur: {
            label: { opacity: 0.2 },
            itemStyle: {
              opacity: 0.2,
            },
            labelLine: {
              lineStyle: {
                opacity: 0.2,
              },
            },
          },
          radius: ['40%', '70%'],
        },
      ],
      legend: {
        data: pieDataList.map((item: { name: any; color: any }) => ({
          name: item.name,
          itemStyle: {
            color: item.color,
          },
        })),
        formatter: getLegendFormat(formatMessage),
      },
    };
  }, [filter, data, formatMessage]);

  return (
    <EChartCommon
      optionsProps={{ type: 'pie', pieLabelAlignTo: 'edge' }}
      height={height}
      options={options}
      ref={eChartsRef}
    ></EChartCommon>
  );
}
